import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import {
  PARTNER_SESSION_MAX_MS,
  PARTNER_SESSION_TIMEOUT_EVENT,
  partnerSessionStartedStorageKey,
} from "./partnerSession";

const CHECK_INTERVAL_MS = 60 * 1000;

export default function PartnerSessionMaxWatcher({ portalId, loginPathPrefix }) {
  const location = useLocation();
  const firedRef = useRef(false);

  useEffect(() => {
    const userKey = `naturals_${portalId}_userId`;
    const startedKey = partnerSessionStartedStorageKey(portalId);
    const onLogin =
      loginPathPrefix &&
      (location.pathname === loginPathPrefix ||
        location.pathname === `${loginPathPrefix}/`);

    const hasUser = Boolean(localStorage.getItem(userKey));

    if (!hasUser || onLogin) {
      firedRef.current = false;
      return undefined;
    }

    const fireTimeout = () => {
      if (firedRef.current) return;
      firedRef.current = true;
      window.dispatchEvent(
        new CustomEvent(PARTNER_SESSION_TIMEOUT_EVENT, {
          detail: {
            message:
              "Your partner session has ended after 16 hours. Please sign in again.",
          },
        }),
      );
    };

    const check = () => {
      const raw = localStorage.getItem(startedKey);
      const started = raw ? Number(raw) : 0;
      if (!started || Number.isNaN(started)) {
        localStorage.setItem(startedKey, String(Date.now()));
        return;
      }
      if (Date.now() - started >= PARTNER_SESSION_MAX_MS) {
        fireTimeout();
      }
    };

    check();
    const timer = window.setInterval(check, CHECK_INTERVAL_MS);
    return () => window.clearInterval(timer);
  }, [location.pathname, loginPathPrefix, portalId]);

  return null;
}
